<div class="custom-snackbar rounded-8 bg-light bg-light-{{alertColor}} bc-{{alertColor}}">
  @if (alertColor!='normal') {
  <span class="featured-icon">
    <span class="icon-dialog">
      <span class="iconify routeIcon text-{{alertColor}}" [attr.data-icon]="data.typeAlertEnum"></span>
    </span>
  </span>
  }
  @if (data.label){
  <span matSnackBarLabel class="d-flex flex-column">
    @if (title!='') {
    <span class="f-w-600 p-b-6">{{title}}</span>
    }
    <span style="white-space: pre-line;text-align: left;">{{data.label}}</span>
  </span>
  }
  <span matSnackBarActions>
    @if (data.labelActionButton) {
    <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()" class="f-w-600">
      {{data.labelActionButton}}
    </button>
    } @else {
    <button mat-icon-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">
      <i matPrefix class="iconify icon-20" data-icon="gg:close"></i>
    </button>
    }
  </span>
</div>
